/**
 * Validation schema for buyer forms using Yup
 * Based on the original validation from choco-admin-buyers
 */

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { BuyerFormData } from '../types/buyerForm';

const validateRequiredString = (value: string | undefined | null): boolean =>
  Boolean(value?.trim());

export const buyerFormValidationSchema = yup.object({
  name: yup
    .string()
    .test('nameRequired', 'Buyer name is required', validateRequiredString)
    .required('Buyer name is required'),
  displayName: yup.string().optional(),
  fullAddress: yup.string().required('Address is required'),
  deliveryComment: yup.string().optional(),
  addressCity: yup.string().optional(),
  addressCountry: yup.string().optional(),
  isTest: yup.boolean().required().default(false),
  addressLatitude: yup.number().optional(),
  addressLongitude: yup.number().optional(),
  addressUTCOffset: yup.number().optional(),
  addressSource: yup
    .string()
    .oneOf(['custom', 'google'] as const)
    .default('custom'),
  addressGooglePlaceId: yup.string().optional(),
  addressGoogleAddressId: yup.string().optional(),
});

export const buyerFormResolver = yupResolver<BuyerFormData>(
  buyerFormValidationSchema
);
